import React, { useState } from 'react';
import { Select, Spin } from 'antd';
import api from '../../../services/api';
import debounce from 'lodash/debounce';

const { Option } = Select;

function SearchNcm({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = debounce(async (searchText) => {
    setLoading(true);
    try {
      const response = await api.post('filters/ncms', { code: searchText });
      const newOptions = response.data.map(item => ({
        label: `${item.code} - ${item.name}`,
        value: item.code
      }));
      setOptions(newOptions);
    } catch (error) {
      console.error('Error fetching options:', error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, 500);

  const handleSearch = (searchText) => {
    if (searchText) {
      fetchOptions(searchText);
    } else {
      setOptions([]);
    }
  };

  const handleChange = (selectedValue) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      showSearch
      style={{ width: '100%' }}
      placeholder="Type to search for merchandise"
      optionFilterProp="children"
      value={value}
      onChange={handleChange}
      onSearch={handleSearch}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
    >
      {options.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
}

export default SearchNcm;